import { TimeZoneInfoHeader } from '@/ui-components/atoms/TimeZoneInfoHeader/TimeZoneInfoHeader';
import styles from './schedule.module.scss';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';

interface ScheduleGroupProps {
    children: React.ReactElement | React.ReactElement[];
}

export default function ScheduleGroup(props: ScheduleGroupProps): React.JSX.Element {
    return (
        <Grid container>
            <Grid col={{ sm: 12, lg: 10 }} start={{ sm: 1, lg: 2 }}>
                <TimeZoneInfoHeader className={styles.scheduleLineupHeader} />
                <>{props.children}</>
            </Grid>
        </Grid>
    );
}
